import React from 'react';

import { CompanyType } from 'src/api';
import { Modal } from 'src/components/common';
import { RevenueShareReportGeneratingModalContent } from 'src/components/revenueShare';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export type RevenueShareReportGeneratingModalProps = {
  companyId?: string;
  companyType?: CompanyType;
};

export const RevenueShareReportGeneratingModal: React.FC<
  ModalV2Props<RevenueShareReportGeneratingModalProps>
> = ({ id, companyId, companyType }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Generate Revenue Share Report"
      maxWidth={550}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <RevenueShareReportGeneratingModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        companyId={companyId}
        companyType={companyType}
      />
    </Modal>
  );
};
